/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { CpdsStyledTag, CpdsFilterToken } from './styles/cpds-tag-style';
import { CpdsTagsProps } from './typings';
import { themeStyleClass } from '../utils/cpds-utils';

const CpdsTag: React.FC<CpdsTagsProps> = (props) => {
  const { domRef, exClasses = '', children, filterApplied = false, themeTypography, ...rest } = props;
  const className = themeStyleClass('cpds-tags', themeTypography, exClasses);

  return (
    <CpdsStyledTag className={className} ref={domRef} filterApplied={filterApplied} {...rest}>
      {children}
      {filterApplied && <CpdsFilterToken />}
    </CpdsStyledTag>
  );
};

export default CpdsTag;
